import { memo } from 'react';

import { AssetTaggingTaskCompletedPanelItem } from '~/components/AssetTaggingTasks/AssetTaggingTaskCompletedPanelItem';
import { AssetTaggingTaskFailedPanelItem } from '~/components/AssetTaggingTasks/AssetTaggingTaskFailedPanelItem';
import { AssetTaggingTaskInProgressPanelItem } from '~/components/AssetTaggingTasks/AssetTaggingTaskInProgressPanelItem';
import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';
import { type AssetTaggingTask } from '~/store/tasks/types';

export type AssetTaggingTasksPanelProps = {
  assetTaggingTasks: AssetTaggingTask[];
  onCancel: (localTaskId: AssetTaggingTask['localTaskId']) => void;
  onClear: (localTaskId: AssetTaggingTask['localTaskId']) => void;
};

export const AssetTaggingTasksPanel = memo(({ assetTaggingTasks, onCancel, onClear }: AssetTaggingTasksPanelProps) => {
  return (
    <div data-testid="ASSET_TAGGING_TASKS_PANEL">
      {assetTaggingTasks.map((task) => {
        return (
          <PaneContainer key={task.localTaskId} className="mb-2 last:mb-0">
            {task.status === 'in-progress' ? (
              <AssetTaggingTaskInProgressPanelItem onCancel={() => onCancel(task.localTaskId)} />
            ) : null}
            {task.status === 'completed' ? (
              <AssetTaggingTaskCompletedPanelItem onClear={() => onClear(task.localTaskId)} {...task} />
            ) : null}
            {task.status === 'error' ? (
              <AssetTaggingTaskFailedPanelItem onClear={() => onClear(task.localTaskId)} {...task} />
            ) : null}
          </PaneContainer>
        );
      })}
    </div>
  );
});

AssetTaggingTasksPanel.displayName = 'AssetTaggingTasksPanel';
